export default {
    methods: {
        $getContentLabel(contentList, contentId) {
            var content = contentList.find(item => item.id == contentId);
            if (this.$checkNull(content)) {
                return content.label;
            }
            return '';
        },
        $processData(data) {
                if (data.code === '501') return;

                var hashTable = new Object();
                data.forEach((prestationOption, index) => {

                    //-- Doesn't like an empty index (creating a one char space one)
                    if (prestationOption.text3 == '') prestationOption.text3 = ' '; else prestationOption.text3 = prestationOption.text3.replace(/^[0-9]\-/,'');
                    if (prestationOption.text2 == '') prestationOption.text2 = ' '; else prestationOption.text2 = prestationOption.text2.replace(/^[0-9]\-/,'');
                    
                    if (!hashTable.hasOwnProperty(prestationOption.text2))
                        hashTable[prestationOption.text2] = new Object();

                    if (hashTable[prestationOption.text2][prestationOption.text3] == undefined)
                        hashTable[prestationOption.text2][prestationOption.text3] = [];

                    hashTable[prestationOption.text2][prestationOption.text3].push({ value: prestationOption.id, label: prestationOption.label });
                });   
                return hashTable;
        },
        $loadDynContent() {
            //-- Loading holidays for this year and the next
            console.log("Loading Dyn Content");
            this.$store.state.contents.holidays = this.$holidays((new Date()).getFullYear()).concat(this.$holidays((new Date(new Date().setFullYear(new Date().getFullYear() + 1))).getFullYear()));

            
            //-- Intializing options
            this.$store.state.contents.prestationOptions = {familyRight: {deed: [], constitution: []}, commonAct: {deed: [], constitution: []}, raw: {}};
            
            this.$AJAX.get(`Data/contentByPage/writer/family_right/common_act`).then(data => {
                if (data.code === '501') return;
            
                this.$store.state.contents.prestationOptions.raw = data;

                //-- Getting the writers list 
                //-- Prestation Options
                var tmpWriter = [];
                var tmpFamilyRightDeed = [];
                var tmpFamilyRightCon = [];
                var tmpActDeed = [];
                var tmpActCon = [];
                data.forEach(function (item) {
                    if (item.page.id == 'family_right' && item.fl1 == '0')
                        tmpFamilyRightDeed.push(item);
                    if (item.page.id == 'family_right' && item.fl1 == '1')
                        tmpFamilyRightCon.push(item);
                    if (item.page.id == 'common_act' && item.fl1 == '0')
                        tmpActDeed.push(item);
                    if (item.page.id == 'common_act' && item.fl1 == '1')
                        tmpActCon.push(item);
                    if (item.page.id == 'writer')
                        tmpWriter.push({ label: item.label, id: item.id });

                });
                this.$store.state.contents.writers = tmpWriter;
                this.$store.state.contents.prestationOptions.familyRight.deed = this.$processData(tmpFamilyRightDeed);
                this.$store.state.contents.prestationOptions.familyRight.constitution = this.$processData(tmpFamilyRightCon);
                this.$store.state.contents.prestationOptions.commonAct.deed = this.$processData(tmpActDeed);
                this.$store.state.contents.prestationOptions.commonAct.constitution = this.$processData(tmpActCon);
                
                
                this.$AJAX.get('/Data/configList/page/order_status/order_delay/prestation_type/order_type/format_deed').then(data => {
                    if (data.code === '501') return;

                    this.$store.state.contents.configData = data;
                    this.$store.state.contents.configFilterData.orderStatus = data.filter(item => item.type == 'order_status');

                    //-- Formating for radio button
                    var tmpArray = [];
                    data.filter(item => item.type == 'order_delay').forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    this.$store.state.contents.configFilterData.orderDelay = tmpArray;

                    tmpArray = [];
                    data.filter(item => item.type == 'prestation_type').forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    this.$store.state.contents.configFilterData.prestationTypes = tmpArray;

                    tmpArray = [];
                    data.filter(item => item.type == 'order_type').forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    this.$store.state.contents.configFilterData.orderTypes = tmpArray;

                    var tmpArray = [];
                    data.filter(item => item.type == 'format_deed').forEach(function (item) {
                        tmpArray.push({ text: item.label, value: item.id });
                    });
                    this.$store.state.contents.configFilterData.formatDeed = tmpArray;
                    this.$store.dispatch('dynContentLoaded');
                });                
            });


        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/dyn-contents.js